import { FunctionalComponent, h } from 'preact';
import Button from '../../components/Button';
import { DefaultUISettings } from '@usercentrics/cmp-browser-sdk';
import { ViewButtonProps } from './interface';
import { useSettingsContext } from '../../contexts/SettingsContext';
import { useTheme } from 'styled-components';

const AcceptAllButton: FunctionalComponent<ViewButtonProps> = ({ disabled, onClick }) => {
  const { settings } = useSettingsContext();
  const ui = settings.ui as DefaultUISettings;
  const theme = useTheme();

  return (
    <Button
      backgroundColor={theme.ui.buttons.accept.bg}
      disabled={disabled}
      label={ui.buttons.acceptAll.label}
      onClick={onClick}
      testid="uc-accept-all-button"
      textColor={theme.ui.buttons.accept.text}
    />
  );
};

export default AcceptAllButton;
